import BlockComponentValue from './BlockComponentValue';

class BlockComponentMap implements BlockComponentValue {
  settings: any;
  value?: string;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockComponentMap {
  export function make(html: string): BlockComponentMap {
    return {
      settings: {},
      value: html,
    };
  }
}

export default BlockComponentMap;
